<script lang="ts">
  const effectiveDate = "2026년 7월 16일";
</script>

<svelte:head>
  <title>개인정보처리방침 | TripHelper</title>
</svelte:head>

<div
  class="min-h-screen bg-app px-4 py-10"
  style="word-break: keep-all; overflow-wrap: break-word;"
>
  <div class="w-full max-w-2xl mx-auto">
    <div class="card">
      <h1 class="text-2xl font-bold text-primary">개인정보처리방침</h1>
      <p class="text-sm text-muted mt-2">시행일: {effectiveDate}</p>

      <div class="mt-8 space-y-8 text-sm text-secondary leading-relaxed">
        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            1. 서비스 개요
          </h2>
          <p>
            TripHelper(이하 "서비스")는 여행 기록·계획·정산을 돕는 앱으로,
            Dcode(이하 "운영자")가 운영합니다. 운영자는 이용자의
            개인정보를 소중히 다루며, 관련 법령을 준수합니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            2. 수집하는 개인정보 항목
          </h2>
          <ul class="list-disc list-inside space-y-1">
            <li>
              로그인 식별자: 1Pass(logi) SSO 로그인 시 전달되는
              이메일 주소, 닉네임
            </li>
            <li>
              공유 여행 데이터: 여러 명이 함께 사용하는 공유 여행
              기능을 이용할 때 서버에 저장되는 여행 정보, 일정,
              지출 내역, 투표 데이터
            </li>
            <li>게스트 참여 정보: 초대 링크로 게스트 참여 시 입력한 닉네임</li>
          </ul>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            3. 로컬 우선 저장 원칙
          </h2>
          <p>
            공유하지 않은 여행, 지출, 사진, 블로그 데이터는 이용자의
            기기에만 저장되며 서버로 전송되지 않습니다. 여러 명과
            함께 여행을 공유하기로 선택한 경우에 한해 해당 여행과
            관련된 데이터만 서버에 저장됩니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            4. 개인정보의 수집 및 이용 목적
          </h2>
          <ul class="list-disc list-inside space-y-1">
            <li>1Pass(logi) SSO 기반 회원 식별 및 로그인 유지</li>
            <li>공유 여행 내 일정·지출·정산·투표 기능 제공</li>
            <li>게스트 참여자 식별 및 여행 공유 기능 제공</li>
          </ul>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            5. AI 기능과 외부 서비스 연동
          </h2>
          <p>
            AI 여행기 생성 등 AI 기능을 이용하는 경우, 이용자가
            직접 입력한 API 키를 통해 외부 AI 서비스로 요청이
            전달됩니다. 해당 API 키는 이용자의 기기에만 저장되며
            운영자의 서버에는 저장되지 않습니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            6. 개인정보의 보유 및 파기
          </h2>
          <p>
            이용자가 계정 삭제를 요청하는 경우, 운영자는 서버에
            저장된 관련 데이터를 삭제합니다. 계정 삭제 및 개인정보
            관련 문의는 아래 문의처로 연락해 주시기 바랍니다.
          </p>
        </section>

        <section>
          <h2 class="text-base font-semibold text-primary mb-2">
            7. 문의처
          </h2>
          <p>
            개인정보 관련 문의는 <a
              href="mailto:support@1pass.dev"
              class="text-accent underline">support@1pass.dev</a
            >로 연락해 주시기 바랍니다.
          </p>
        </section>
      </div>

      <a
        href="/"
        class="block mt-10 text-sm text-muted hover:text-secondary transition-colors duration-200"
      >
        홈으로 돌아가기
      </a>
    </div>
  </div>
</div>
